import { request } from '@@/plugin-request';

export async function query(params) {
  return request('/api/lessons', {
    method: 'get',
    params,
  });
}

export async function create(params) {
  return request('/api/lessons', {
    method: 'post',
    data: params,
  });
}

export async function getSimilarScheduledLessons(params) {
  return request('/api/lessons/similarScheduled', {
    method: 'get',
    params,
  });
}

export async function update(params) {
  return request('/api/lessons', {
    method: 'put',
    data: params,
  });
}

export async function getByUser(params) {
  return request('/api/lessons/getByUser', {
    method: 'get',
    params,
  });
}

export async function getPermittedOperations(params) {
  return request('/api/lessons/permittedOperations', {
    method: 'get',
    params,
  });
}

export async function getUsers(params) {
  return request('/api/lessons/getUsers', {
    method: 'get',
    params,
  });
}

export async function getById(params) {
  return request('/api/lessons/getById', {
    method: 'get',
    params,
  });
}

export async function getLessonsDetail(params) {
  return request('/api/lessons/detail', {
    method: 'post',
    params,
  });
}

export async function getLessonsByCourse(params) {
  return request('/api/lessons/getByCourse', {
    method: 'GET',
    params,
  });
}

export async function connectLessons(payload) {
  return request('/api/lessons/connectLessons', {
    method: 'POST',
    data: payload,
  });
}

export async function getConnectedLessonsByParentLessonId(params) {
  return request('/api/lessons/getConnectedLessonsByParentLessonId', {
    method: 'GET',
    params,
  });
}

export async function getLessonsTotalDuration(params) {
  return request('/api/lessons/duration', {
    method: 'GET',
    params,
  });
}

export async function createZoomMeeting(data) {
  return request('/api/lessons/meetings', {
    method: 'post',
    data,
  });
}

export async function query4Table(params) {
  return request('/api/lessons/table', {
    method: 'get',
    params,
  });
}

export async function updateQualityNote(params) {
  return request('/api/lessons/updateQualityNote', {
    method: 'put',
    data: params,
  });
}

export async function putTeachingComplaints(payload) {
  return request('/api/teachingComplaints', {
    method: 'post',
    data: payload,
  });
}

export async function getAllMatchMaker() {
  return request('/api/teachingComplaints/matchmaker', {
    method: 'get',
  });
}

export async function updateUsage(data) {
  return request('/api/lessons/usage', {
    method: 'put',
    data,
  });
}

export async function deleteLesson(id, data) {
  return request(`/api/lessons/${id}`, {
    method: 'delete',
    data,
  });
}

export async function exportLessonsData(payload) {
  return request('/api/lessons/exportLessonsData', {
    method: 'post',
    data: payload,
  });
}

function getAuthHeaders() {
  const headers = {};
  const token = window.localStorage.getItem('token');
  const ip = window.localStorage.getItem('ip');

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (ip) {
    headers.ip = ip;
  }

  return headers;
}

function parseAttachmentFilename(contentDisposition) {
  if (!contentDisposition) {
    return null;
  }

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const quotedMatch = contentDisposition.match(/filename="([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1];
  }

  const plainMatch = contentDisposition.match(/filename=([^;]+)/i);
  return plainMatch?.[1]?.trim() || null;
}

export async function exportProductConsumptionWorkbook({ month, include = 'all' } = {}) {
  const query = new URLSearchParams({
    startMonth: month,
    endMonth: month,
    include,
    format: 'xlsx',
  });

  const response = await fetch(`/api/datacenter/product-consumption/monthly?${query.toString()}`, {
    method: 'GET',
    headers: getAuthHeaders(),
    credentials: 'include',
  });

  if (!response.ok) {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const errorPayload = await response.json();
      throw new Error(errorPayload?.message || '课消导出失败');
    }

    const errorText = await response.text();
    throw new Error(errorText || '课消导出失败');
  }

  return {
    blob: await response.blob(),
    filename:
      parseAttachmentFilename(response.headers.get('content-disposition')) ||
      `product-consumption-${month}-to-${month}.xlsx`,
  };
}

export async function getTeacherCalendarLessonsData(params) {
  return request('/api/lessons/teacherCalendar', {
    method: 'get',
    params,
  });
}

export async function getInterviews(params) {
  return request('/hr/api/interview', {
    method: 'get',
    params,
  });
}

export async function getInterviewsByLessonId(params) {
  return request('/hr/api/interview/getByLessonId', {
    method: 'get',
    params,
  });
}

export async function updateSharingScreenDuration(payload) {
  return request('/api/zoom/sharingScreenDuration', {
    method: 'put',
    data: payload,
  });
}

export async function startLessonVideoRead(lessonId) {
  return request(`/api/lessons/${lessonId}/videoRead`, {
    method: 'post',
  });
}

export async function getLessonVideoReadStatus(lessonId) {
  return request(`/api/lessons/${lessonId}/videoRead`, {
    method: 'get',
  });
}

export async function chatLessonVideo(lessonId, payload) {
  return request(`/api/lessons/${lessonId}/videoChat`, {
    method: 'post',
    data: payload,
  });
}

// 聊天附件上传：走 /api/upload/file（默认 savvyuni-intl-erp 公共读桶），
// 返回的公网 URL 供多模态模型/后端直接拉取
export async function uploadChatAttachment(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request(`/api/upload/file`, {
    method: 'POST',
    body: formData,
  });
}

export async function generateLessonReviewTemplate(lessonId, payload) {
  return request(`/api/lessons/${lessonId}/videoReviewTemplate`, {
    method: 'post',
    data: payload,
  });
}

export async function requestDeleteLesson(payload) {
  return request('/api/lessons/requestDelete', {
    method: 'post',
    data: payload,
  });
}

export async function cancelPendingDeleteLessons(payload) {
  return request('/api/lessons/cancelPendingDelete', {
    method: 'put',
    data: payload,
  });
}

export async function exportLessonsByFilter(payload) {
  return request('/api/lessons/exportLessonsByFilter', {
    method: 'post',
    data: payload,
  });
}

export async function getLessonsForPassLessonTask(params) {
  return request('/api/lessons/getLessonsForPassLessonTask', {
    method: 'get',
    params,
  });
}

export async function splitAndMoveLesson(data) {
  return request('/api/lessons/splitAndMoveLesson', {
    method: 'post',
    data,
  });
}
